<form #form="ngForm" (ngSubmit)="update.emit(true)" [loading]="loading()">
	<fieldset>
		<p class="title-xs font-serra mb-1">Modifier la carte</p>
		<p class="opacity-60 mb-4">Corrige les informations de la carte si besoin</p>

		<!-- langue -->
		<fieldset class="fieldset mb-2">
		  <!-- <legend class="fieldset-legend ">Langue de la carte</legend> -->
		  <div class="lang-container">
			  @for(lang of langs; track lang){
			  	  <label [ngClass]="{'mr-2': !$last}" class="lang-choice" for="lang-{{lang}}">
					<input id="lang-{{lang}}" name="lang" type="radio" [(ngModel)]="card().lang" [value]="lang"/>
		    		<span [ngClass]="{'badge-soft': card().lang!=lang}" class="badge badge-soft badge-primary">
		    			<img class="img-lang" src="img/skin/flag-{{lang}}.svg"/>
		    		</span>
				  </label>
			  }
		  </div>
		</fieldset>

		<!-- etat -->
		<fieldset class="fieldset">
		    <!-- <legend class="fieldset-legend ">Etat de la carte</legend> -->
			<select class="select w-full" name="condition" [(ngModel)]="card().condition" required>
			  <option [ngValue]="undefined" selected>Etat de la carte</option>
			  @for(c of conditions(); track c.ref){
				<option [value]="c.ref">{{c.name}}</option>
			  }
			</select>
		</fieldset>

		<!-- variante -->
		<fieldset class="fieldset">
		    <!-- <legend class="fieldset-legend ">Variante</legend> -->
			<select class="select w-full" name="variante" [(ngModel)]="card().variante">
			  <option [ngValue]="undefined" selected>Variante de la carte</option>
			  <option [ngValue]="null" selected>Aucune variante</option>
			  @for(v of variantes(); track v.ref){
				<option [value]="v.ref">{{v.name}}</option>
			  }
			</select>
		</fieldset>

		<label class="floating-label mt-4">
		  <span>Valeur de la carte</span>
		  <input type="number" placeholder="Valeur de la carte" name="amount" class="input input-md w-full" [(ngModel)]="card().amount" />
		</label>
	</fieldset>

	<div class="btn-container mt-4">
		<button class="btn btn-primary btn-gradient" [disabled]="form.invalid">
			Modifier
		</button>
	</div>
</form>